  <!-- Animated -->
            <div class="animated fadeIn">
                <!-- <h3>Analyst Panel</h3>
                <br/> -->
         
                <!--  Traffic  -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-body" style="min-height: 600px;">
                                <h4 class="box-title">Upload File </h4>
                                <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
                           <br/>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Data Type
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="selectSm" id="selectSm" class="form-control-sm form-control" [(ngModel)]="dataType">
                                            <option value="Segment">Segment</option>
                                            <option value="Form">Form</option>   
                                            <option value="Financial Highlights">Financial Highlights</option>
                                           <!-- <option value="Financial Highlights">Financial Highlights</option>-->
                                            <option value="Gross & Net Statistics">Gross & Net Statistics</option>
                                            <!--<option value="Detailed Motor Crop Breakups">Detailed Motor Crop Breakups</option>
                                            <option value="Motor State-wise Incurred Claims">Motor State-wise Incurred Claims</option>-->
                                            <option  value="Data on Motor">Data on Motor</option>
                                            <option  value="Reinsurance">Reinsurance</option> 
                                            <!-- <option  value="MotorPremium">Motor Premium</option> -->

                                            <option value="Large Loss">Large Loss</option>

                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group" id="fileYearCont" *ngIf="dataType=='Segment'" >
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Year
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="fileYear" id="fileYear" [(ngModel)]="fileYear" class="form-control-sm form-control">
                                            <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group" id="filefYearCont" *ngIf="dataType!='Segment'">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Year
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="filefYear" id="filefYear" [(ngModel)]="filefYear" class="form-control-sm form-control">
                                            <option  value="{{fyr}}" *ngFor="let fyr of yearfArr">{{fyr}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group"  id="selectMonthCont" *ngIf="dataType=='Segment'">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Month
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="selectMonth" id="selectMonth" [(ngModel)]="selectMonth" class="form-control-sm form-control">
                                            <option value="">Please select</option>
                                            <option value="January">January</option>
                                            <option value="February">February</option>
                                            <option value="March">March</option>
                                            <option value="April">April</option>
                                            <option value="May">May</option>
                                            <option value="June">June</option>
                                            <option value="July">July</option>
                                            <option value="August">August</option>
                                            <option value="September">September</option>
                                            <option value="October">October</option>
                                            <option value="November">November</option> 
                                            <option value="December">December</option> 
                                        </select>
                                    </div>
                                </div>

                                <div class="row form-group" id="fileQuarterCont" *ngIf="dataType == 'Form' || dataType == 'Financial Highlights' || dataType == 'Data on Motor' || dataType == 'Reinsurance' ">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Quarter
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="fileQuarter" id="fileQuarter" [(ngModel)]="fileQuarter" class="form-control-sm form-control">
                                            <option value="Q1">Q1</option>
                                            <option value="Q2">Q2</option>
                                            <option value="Q3">Q3</option>
                                            <option value="Q4">Q4</option>                                            
                                        </select>
                                    </div>
                                </div>
                                 <div class="row form-group">
                                    <div class="col col-md-3"><label for="file-multiple-input" class=" form-control-label">Upload</label></div>
                                    <div class="col-12 col-md-9"><input type="file" id="file-multiple-input" name="file-multiple-input"  class="form-control-file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ></div>
                                </div>
                                
                               


                                


                                

                                <div class="row form-group">
                                    <div class="col col-md-3"></div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-actions form-group">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="uploadFile()">Submit</button>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-3">
                                        <div class="form-actions form-group">
                                            <a *ngIf="dataType=='Segment'" href="{{downLoadPath}}format/Segment-wise_Format.xlsx" id="segFor">Download Template</a>
                                            <a  *ngIf="dataType=='Form'" href="{{downLoadPath}}format/Forms _I-X_Format.xlsx" id="FormFor">Download Template</a>
                                            <a *ngIf="dataType=='Financial Highlights'" href="{{downLoadPath}}format/Financial_Highlights.xls" id="finhighFor">Download Template</a>
                                            <a *ngIf="dataType=='Gross & Net Statistics'" href="{{downLoadPath}}format/Gross_Net_Statistics.xlsx" id="gnstatFor">Download Template</a>
                                            <a *ngIf="dataType=='Data on Motor'" href="{{downLoadPath}}format/Data_on_Motor.xlsx" id="dtmotorFor">Download Template</a>
                                            <!-- <a *ngIf="dataType=='MotorPremium'" href="{{downLoadPath}}format/Format_Motor_Premium.xlsx" id="motorPFor">Download Template</a> -->

                                            <a *ngIf="dataType=='Reinsurance'" href="{{downLoadPath}}format/Reinsurance_Data.xlsx" id="reinsFor">Download Template</a>
                                            <a  *ngIf="dataType=='Large Loss'" href="{{downLoadPath}}format/Large_los_ GIC_format.xlsx" id="llossFor">Download Template</a>
                                            
                                            
                                        </div>
                                    </div>
                                    
                                </div>
                               <!-- <div class="row form-group">
                                    <div class="col col-md-12"><h4 class="box-title errHead">Unsuccessful Upload – Error messages below</h4></div>
                                    <div class="col col-md-12" id="errCont" style="border: #FF0000 2px solid;"></div>
                                </div>-->


                                <div class="row form-group" *ngIf="hasError">
                                    <div class="col col-md-12">
                                        <div class="card border border-success">
                                            <div class="card-header">
                                                <strong class="card-title">Unsuccessful Upload – Error messages below</strong>
                                            </div>
                                            <div class="card-body" id="errCont">
                                                <p class="card-text" *ngFor="let err of errMsg">{{err}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div><!-- /# column -->
                </div>
                <!--  /Traffic -->
                <div class="clearfix"></div>
               
              
               
                
            </div>
            <!-- .animated -->






<div class="loaderbox" *ngIf="loaderVisibility">
    <div class="load">
        <img src="assets/images/loading.gif" alt="">
    </div>
</div>



















